import "./../areaChart.css";

import * as d3 from "d3";
import React, { useEffect } from "react";

interface SalaryVersusTimeLineProps {
    xScale: d3.ScaleLinear<number, number>;
    yScale: d3.ScaleLinear<number, number>;
    data: {
        percentile: number;
        salary: number;
    }[];
    mobile: boolean;
    d3Id: string;
}

export const SalaryVersusTimeLine = (props: SalaryVersusTimeLineProps) => {
    const { xScale, yScale, data, mobile, d3Id } = props;
    useEffect(() => {
        //drawing the line
        const line = d3
            .line()
            .x(d => xScale((d as unknown as { percentile: number }).percentile))
            .y(d => yScale((d as unknown as { salary: number }).salary));

        //appending the line to the chart
        d3.select(`#${d3Id}`)
            .selectAll(".lines")
            .selectAll(".line-group")
            .data([data])
            .enter()
            .append("svg:path")
            .attr("class", "line")
            .attr("d", d =>
                line(d as unknown as [salary: number, percentile: number][])
            )
            .style("stroke", "#54d2c7")
            .style("stroke-width", 0.5)
            .style("fill", "none");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <g className="lines"></g>;
};
